import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { Image } from '../../uiComponents/layout/Image';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col, Form } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { PasswordFormGroup, TextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationResult, ValidationError } from '../../infrastructure/ValidationResult';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { EksternBrugerAktiverPublicModel } from '../../models/EksternBrugerAktiverPublicModel';
import { EksternBrugerAktiveringsPublicModel } from '../../models/EksternBrugerAktiveringsPublicModel';
import NotificationModule from '../../uiComponents/layout/Notification';
import { Loading } from '../../uiComponents/Loading';

interface EksternAdgangAktiverProps extends RouteComponentProps<any> {
    
}

interface EksternAdgangAktiverState {
    aktiveringPayload: EksternBrugerAktiverPublicModel;
    aktiveringsModel: EksternBrugerAktiveringsPublicModel;
    isSubmitting: boolean;
    validationResult: ValidationResult;
    aktiveret: boolean;
}

class EksternAdgangAktiver extends React.Component<EksternAdgangAktiverProps, EksternAdgangAktiverState> {
    constructor(props: EksternAdgangAktiverProps) {
        super(props);

        const aktiveringPayload = new EksternBrugerAktiverPublicModel();
        aktiveringPayload.name = '';
        aktiveringPayload.invitationsPublicId = '';
        aktiveringPayload.password = '';
        aktiveringPayload.passwordConfirmed = '';

        const aktiveringsModel = new EksternBrugerAktiveringsPublicModel();
        aktiveringsModel.invitationsPublicId = '';
        aktiveringsModel.invitationsLinkErForældet = false;
        aktiveringsModel.brugerErAlleredeAktiveret = false;

        this.state = { aktiveringPayload: aktiveringPayload, aktiveringsModel: aktiveringsModel, isSubmitting: false, aktiveret: false, validationResult: new ValidationResult() };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const aktiveringsId = this.props.match.params.id;
        const self = this;
        createApiCaller().getAktiverEksternBruger(aktiveringsId).then(response => {
            const aktiveringPayload = self.state.aktiveringPayload;
            aktiveringPayload.invitationsPublicId = response.invitationsPublicId;

            self.setState({ aktiveringsModel: response, aktiveringPayload: aktiveringPayload });
        });
    }

    onChange(fieldName: string, value: any) {
        const aktiveringPayload = this.state.aktiveringPayload;
        aktiveringPayload[fieldName] = value;
        const newValidationResult = this.state.validationResult;
        newValidationResult.errorMessages = [];

        this.setState({ aktiveringPayload: aktiveringPayload, validationResult: newValidationResult });
    }

    onSubmit() {
        const { password, passwordConfirmed, name } = this.state.aktiveringPayload;

        if (!this.validateForm(password, passwordConfirmed, name)) {
            return;
        }

        const self = this;
        self.setState({ isSubmitting: true });

        createApiCaller().aktiverEksternBruger(this.state.aktiveringPayload).then(response => {
            NotificationModule.showSuccess('', 'Din bruger er aktiveret og du kan logge ind');
            self.setState({ aktiveret: true, isSubmitting: false });
        });
    }

    validateForm(password: string, confirmPassword: string, name: string): boolean {
        let isValid = true;

        if (password === '') {
            const validationError = new ValidationError('password', 'Password skal udfyldes');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        } else if (confirmPassword === '') {
            const validationError = new ValidationError('passwordConfirmed', 'Bekræft password skal udfyldes');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        } else if (password !== confirmPassword) {
            const validationError = new ValidationError('password', 'De to passwords skal være ens');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        }

        if (name === '') {
            const validationError = new ValidationError('name', 'Navn skal angives');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        }

        return isValid;
    }

    aktiverBrugerText() {
        return (
            <div>
                <p>Du er blevet inviteret til at være ekstern bruger på {getSite().navn}.</p>
                <p>For at bruge {getSite().navn} skal du aktivere din bruger.</p>
                <br />
            </div>
        );
    }

    getAktiverBrugerContent() {
        return (
            <PageWrapper>
                <ContentWrapper>
                    <Loading isLoading={this.state.aktiveringsModel.invitationsPublicId === ''}>
                        <SectionGroup>
                            <Section>
                                <Form onSubmit={this.onSubmit}>
                                    <div id='aktiver-profil-page'>
                                        <Row>
                                            <Col md={2} mdOffset={2} className='image'>
                                                <Image source='login-person.png' />
                                            </Col>
                                            <Col md={6}>
                                                <h1>Aktiver din bruger</h1>
                                                {this.aktiverBrugerText()}
                                                <TextFormGroup 
                                                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                    label='Navn*'
                                                    name='name'
                                                    placeholder='Indtast navn'
                                                    value={this.state.aktiveringPayload.name}
                                                    onChange={this.onChange}
                                                />
                                                <PasswordFormGroup 
                                                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                    label='Password*'
                                                    name='password'
                                                    placeholder='Indtast password'
                                                    value={this.state.aktiveringPayload.password}
                                                    onChange={this.onChange}
                                                />
                                                <PasswordFormGroup 
                                                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                    label='Bekræft password*'
                                                    name='passwordConfirmed'
                                                    placeholder='Indtast password igen'
                                                    value={this.state.aktiveringPayload.passwordConfirmed}
                                                    onChange={this.onChange}
                                                />
                                                <SubmitButton isSubmitting={this.state.isSubmitting}>{this.state.isSubmitting ? 'Vent...' : 'Aktiver'}</SubmitButton>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }

    getUdloebetLinkContent(forældet: boolean, alleredeAktiveret: boolean) {
        const header = forældet ? 'Aktiveringslink er udløbet' : 'Brugeren er allerede aktiveret';
        const content = forældet ? 'Dette aktiveringslink er udløbet og er derfor ikke længere gyldigt. Kontakt venligst en administrator for at få tilsendt et nyt aktiveringslink.'
                                : 'Dette aktiveringslink er allerede brugt og er derfor ikke længere gyldigt.';

        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <Section>
                            <Row>
                                <Col md={2} mdOffset={2} className='image'>
                                    <Image source='login-person.png' />
                                </Col>
                                <Col md={6}>
                                    <h1>{header}</h1>
                                    <div>
                                        <p>{content}</p>
                                        <br />
                                    </div>
                                </Col>
                            </Row>
                        </Section>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }

    render() {
        const { aktiveret } = this.state;
        const { invitationsLinkErForældet, brugerErAlleredeAktiveret } = this.state.aktiveringsModel;

        if (aktiveret) {
            return <Redirect to='/emaillogin' />;
        }

        if (invitationsLinkErForældet || brugerErAlleredeAktiveret) {
            return this.getUdloebetLinkContent(invitationsLinkErForældet, brugerErAlleredeAktiveret);
        }

        return this.getAktiverBrugerContent();
    }
}

export default EksternAdgangAktiver;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/eksternAdgang/EksternAdgangAktiver.tsx